import React from 'react';
import { motion } from 'framer-motion';

const LegalPageTemplate = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Banner Title */}
      <div className="bg-green-500 py-16 mb-12">
        <h1 className="text-3xl md:text-5xl font-bold text-white text-center">
          {title}
        </h1>
      </div>

      <div className="px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="max-w-8xl mx-auto"
        >
          {subtitle && (
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
              {subtitle}
            </h2>
          )}
          <div className="bg-white rounded-xl shadow-lg p-6 md:p-12">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPageTemplate; 